import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type BooleanBadgeProps = WithClassName<{
	value: boolean
	label: string
	showLabel?: boolean
	size?: 'sm' | 'md'
}>

export const BooleanBadge = ({
	value,
	label,
	showLabel = false,
	size = 'md',
	className
}: BooleanBadgeProps) => {
	const { t } = useTranslation()
	const Icon = value ? CheckIcon : XMarkIcon
	const title = `${label}: ${value ? t('Yes') : t('No')}`
	const isSmall = size === 'sm' && !showLabel

	return (
		<span
			role="img"
			aria-label={title}
			title={title}
			className={cn(
				'inline-flex items-center justify-center',
				isSmall
					? value
						? 'bg-success-soft text-success'
						: 'bg-danger-soft text-danger'
					: value
						? 'bg-success/10 text-success'
						: 'bg-danger/10 text-danger',
				showLabel
					? 'gap-1 rounded-full px-2 py-1 text-[10px] font-semibold'
					: isSmall
						? 'h-5 w-5 rounded-md'
						: 'h-6 w-6 rounded-md',
				className
			)}>
			<Icon
				className={cn(
					isSmall ? 'h-3 w-3 stroke-[3]' : 'stroke-[2.5]',
					!isSmall && (showLabel ? 'h-3 w-3' : 'h-3.5 w-3.5')
				)}
			/>
			{showLabel && label}
		</span>
	)
}
